import { gql } from '@apollo/client';

export const GET_SHOP_DETAILS = gql`
  query GetShopDetails($slug: String!) {
    ShopDetails: shop(slug: $slug) {
      id
      name
      promo
      address
      phones
      latitude
      longitude
      hits
      description
      adsCount
      uri
      workingDays
      workingHours
      logo {
        url
      }
      cover {
        url
      }
      photos {
        url
      }
      videos {
        url
      }
      user {
        id
        legacyId
      }
      categories {
        id
        name
        slug
        path
        count
      }
    }
  }
`;

export const GET_SHOP_ADS = gql`
  query GetShopAds(
    $userLegacyId: ID!
    $categoryId: ID
    $orderType: AdOrderEnum
    $first: Int
    $after: String
    $keywords: String
  ) {
    ShopAds: ads(
      source: MOBILE
      filters: { userLegacyId: $userLegacyId, categoryId: $categoryId }
      orderType: $orderType
      first: $first
      after: $after
      keywords: $keywords
    ) {
      edges {
        node {
          id
          title
          price
          updatedAt
          path
          region
          kinds
          photo {
            url
          }
          isBookmarked
          status
          shop {
            id
            name
            logo {
              url
            }
            workingDays
            workingHours
            uri
            description
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
